"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Img = exports.ImagePlaceholder = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const loader_1 = __importDefault(require("@kawaui/loader"));
const react_1 = require("react");
const styled_components_1 = require("styled-components");
const Styled = __importStar(require("./styled"));
exports.ImagePlaceholder = (0, react_1.forwardRef)((props, ref) => {
    const theme = (0, styled_components_1.useTheme)();
    const Icon = theme.name === 'privalia' ? Styled.PlaceholderIconPrivalia : Styled.PlaceholderIcon;
    return ((0, jsx_runtime_1.jsx)(Styled.ImagePlaceholder, { ref: ref, height: props.height, width: props.width, children: (0, jsx_runtime_1.jsx)(Icon, {}) }));
});
exports.ImagePlaceholder.displayName = 'ImagePlaceholder';
exports.Img = (0, react_1.forwardRef)((props, ref) => {
    const { src, height, width, withLoader, withPlaceholder = true } = props, otherProps = __rest(props, ["src", "height", "width", "withLoader", "withPlaceholder"]);
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [isBroken, setIsBroken] = (0, react_1.useState)(false);
    const onLoadStart = (event) => {
        if (props.onLoadStart)
            props.onLoadStart(event);
        setIsLoading(true);
        setIsBroken(false);
    };
    const onError = (event) => {
        if (props.onError)
            props.onError(event);
        setIsLoading(false);
        setIsBroken(true);
    };
    const onLoad = (event) => {
        if (props.onLoad)
            props.onLoad(event);
        setIsLoading(false);
        setIsBroken(false);
    };
    const cleanedHeight = typeof height === 'string' ? height : height ? height + 'px' : undefined;
    const cleanedWidth = typeof width === 'string' ? width : width ? width + 'px' : undefined;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isLoading && withLoader && ((0, jsx_runtime_1.jsx)(Styled.LoaderContainer, { width: cleanedWidth, height: cleanedWidth, children: (0, jsx_runtime_1.jsx)(loader_1.default, Object.assign({}, otherProps)) })), withPlaceholder && (isBroken || !src) && (0, jsx_runtime_1.jsx)(exports.ImagePlaceholder, Object.assign({ height: cleanedHeight, width: cleanedWidth }, otherProps)), (0, jsx_runtime_1.jsx)(Styled.Image, Object.assign({ ref: ref, src: src }, otherProps, { onLoadStart: onLoadStart, onError: onError, onLoad: onLoad, isHidden: isBroken, height: height, width: width }))] }));
});
exports.Img.displayName = 'Img';
